import { COOKIE_HIDE_VALUE, COOKIE_PREFIX, DEFAULT_DURATION } from 'moduleBase/components/header/confirm-email-notifier/constants';
import app from 'srcJs/App';
import Cookies from 'js-cookie';
export var isNotifierTempSuppressed = function isNotifierTempSuppressed() {
  var user = app.getUser();
  return Cookies.get("".concat(COOKIE_PREFIX).concat(user.getId())) === COOKIE_HIDE_VALUE;
};
export var tempSuppressNotifier = function tempSuppressNotifier() {
  var user = app.getUser();
  var date = new Date();
  date.setTime(date.getTime() + DEFAULT_DURATION * 1000);
  Cookies.set("".concat(COOKIE_PREFIX).concat(user.getId()), COOKIE_HIDE_VALUE, {
    expires: date
  });
};